import { useState, useRef } from "react";
import { Microphone, Stop, Waveform } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api } from "@/lib/api";

// Records mic audio, transcribes via Whisper, then calls onTranscript(text).
export const VoiceButton = ({ onTranscript, idleLabel = "Add More by Voice", className = "", testid = "voice-button" }) => {
  const [recording, setRecording] = useState(false);
  const [busy, setBusy] = useState(false);
  const mediaRef = useRef(null);
  const chunksRef = useRef([]);

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream);
      chunksRef.current = [];
      mr.ondataavailable = (e) => e.data.size > 0 && chunksRef.current.push(e.data);
      mr.onstop = () => { stream.getTracks().forEach((t) => t.stop()); upload(); };
      mr.start();
      mediaRef.current = mr;
      setRecording(true);
    } catch (e) {
      toast.error("Microphone access denied.");
    }
  };

  const stop = () => { setRecording(false); mediaRef.current && mediaRef.current.stop(); };

  const upload = async () => {
    const blob = new Blob(chunksRef.current, { type: "audio/webm" });
    if (blob.size < 800) { toast.error("Recording too short."); return; }
    const fd = new FormData();
    fd.append("audio", blob, "clip.webm");
    setBusy(true);
    try {
      const tr = await api.post("/transcribe", fd);
      const text = tr.data.text?.trim();
      if (!text) { toast.error("Didn't catch that. Try again."); }
      else { await onTranscript(text); }
    } catch (e) {
      toast.error("Voice processing failed.");
    }
    setBusy(false);
  };

  const disabled = busy;
  return (
    <button
      type="button"
      data-testid={testid}
      disabled={disabled}
      onClick={recording ? stop : start}
      className={`h-12 rounded-xl font-bold flex items-center justify-center gap-2 active:translate-y-0.5 transition-transform disabled:opacity-60 ${
        recording ? "bg-red-600 text-white" : "bg-zinc-900 text-white"
      } ${className}`}
    >
      {busy ? <Waveform size={20} weight="fill" className="animate-pulse" /> : recording ? <Stop size={20} weight="fill" /> : <Microphone size={20} weight="fill" />}
      {busy ? "Working…" : recording ? "Tap to stop" : idleLabel}
    </button>
  );
};
